import React from 'react';
const DzModalContext = React.createContext({
    propsDictionary: {},
    openModal: () => new Promise(() => undefined),
    closeModal: () => undefined,
    clearModal: () => undefined,
});
export default DzModalContext;
